// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation-bar--top {
  display: flex;
  margin-left: 2.75rem;
}
.navigation-bar--top.horizontal {
  gap: 20px;
}
.navigation-bar--top::ng-deep .navigation-bar-item {
  height: 3.75rem;
}

@media screen and (max-width: 768px) {
  :host {
    flex: 1;
  }
  .navigation-bar--top {
    margin-left: 0;
    padding-right: 0.75rem;
    gap: 1rem;
    width: 100%;
    justify-content: center;
  }
  .navigation-bar--top::ng-deep .navigation-bar-item {
    width: auto;
  }
}
@media screen and (max-width: 650px) {
  .navigation-bar--top {
    gap: 0.7rem;
  }
}
@media screen and (max-width: 620px) {
  .navigation-bar--top::ng-deep .navigation-bar-item .navigation-bar-item__name {
    font-size: 0.6rem;
  }
}
@media screen and (max-width: 500px) {
  .navigation-bar--top::ng-deep .navigation-bar-item .navigation-bar-item__name {
    font-size: 0.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/navigation-bar/top-bar/top-bar.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,oBAAA;AACJ;AACI;EACI,SAAA;AACR;AAGQ;EACI,eAAA;AADZ;;AAMA;EACI;IACI,OAAA;EAHN;EAME;IACI,cAAA;IACA,sBAAA;IACA,SAAA;IACA,WAAA;IACA,uBAAA;EAJN;EAOU;IACI,WAAA;EALd;AACF;AAUA;EACI;IACI,WAAA;EARN;AACF;AAWA;EAIgB;IACI,iBAAA;EAZlB;AACF;AAkBA;EAIgB;IACI,iBAAA;EAnBlB;AACF","sourcesContent":[".navigation-bar--top {\r\n    display: flex;\r\n    margin-left: 2.75rem;\r\n\r\n    &.horizontal {\r\n        gap: 20px;\r\n    }\r\n\r\n    &::ng-deep {\r\n        .navigation-bar-item {\r\n            height: 3.75rem;\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n    :host {\r\n        flex: 1;\r\n    }\r\n\r\n    .navigation-bar--top {\r\n        margin-left: 0;\r\n        padding-right: 0.75rem;\r\n        gap: 1rem;\r\n        width: 100%;\r\n        justify-content: center;\r\n\r\n        &::ng-deep {\r\n            .navigation-bar-item {\r\n                width: auto;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 650px) {\r\n    .navigation-bar--top {\r\n        gap: 0.7rem;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 620px) {\r\n    .navigation-bar--top {\r\n        &::ng-deep {\r\n            .navigation-bar-item {\r\n                .navigation-bar-item__name {\r\n                    font-size: 0.6rem;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n    .navigation-bar--top {\r\n        &::ng-deep {\r\n            .navigation-bar-item {\r\n                .navigation-bar-item__name {\r\n                    font-size: 0.5rem;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
